import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import FinanceV2Layout from "./FinanceV2Layout";
import { NoteState } from "../../context/notes/NoteState";
import FinanceV2Services from "../../UserServices/FinanceV2Services";
import "./FinanceV2.css";

export default function FinanceV2FiscalPeriods() {
  const { state } = useContext(NoteState);
  const { branch_id } = state;
  const [periods, setPeriods] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    FinanceV2Services.getFiscalPeriods(branch_id)
      .then((res) => setPeriods(res.data?.data || []))
      .catch(() => toast.error("Could not load periods"))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, [branch_id]);

  const closePeriod = async (id, name) => {
    if (!window.confirm(`Close period "${name}"? No new entries can post to closed periods.`)) {
      return;
    }
    try {
      await FinanceV2Services.closeFiscalPeriod(id);
      toast.success("Period closed");
      load();
    } catch (e) {
      toast.error(e.response?.data?.message || "Close failed");
    }
  };

  return (
    <FinanceV2Layout>
      <div className="container-fluid px-0 py-2">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h4 className="mb-0">Fiscal periods</h4>
            <small className="text-muted">Close months to lock posting (QuickBooks month-end)</small>
          </div>
          <Link to="/finance-v2/dashboard" className="btn btn-sm btn-outline-secondary">
            Dashboard
          </Link>
        </div>

        <div className="fv2-table-wrap">
          <table className="table table-sm">
            <thead>
              <tr>
                <th>Period</th>
                <th>Fiscal year</th>
                <th>Start</th>
                <th>End</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={6}>Loading…</td>
                </tr>
              ) : (
                periods.map((p) => (
                  <tr key={p.id}>
                    <td>{p.name}</td>
                    <td>{p.fiscal_year?.name}</td>
                    <td>{p.start_date}</td>
                    <td>{p.end_date}</td>
                    <td>
                      {p.is_closed ? (
                        <span className="badge bg-secondary">Closed</span>
                      ) : (
                        <span className="badge bg-success">Open</span>
                      )}
                    </td>
                    <td>
                      {!p.is_closed && (
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => closePeriod(p.id, p.name)}
                        >
                          Close
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </FinanceV2Layout>
  );
}
